import { render, staticRenderFns } from "./aiBookQuestion.vue?vue&type=template&id=7b89009c&scoped=true&"
import script from "./aiBookQuestion.vue?vue&type=script&lang=js&"
export * from "./aiBookQuestion.vue?vue&type=script&lang=js&"
import style0 from "./aiBookQuestion.vue?vue&type=style&index=0&id=7b89009c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b89009c",
  null
  
)

export default component.exports